import {
  ListItemIcon,
  MenuItem,
  type MenuItemProps,
  Typography,
} from '@mui/material';

export interface PopupMenuItemProps extends MenuItemProps<'a'> {
  actionText: string;
  textProps?: Record<string, unknown>;
  label?: string;
  menuIcon?: React.ReactNode;
  disabled?: boolean;
}

export const PopupMenuItem = ({
  label,
  actionText,
  textProps = {},
  menuIcon,
  ...rest
}: PopupMenuItemProps) => (
  <MenuItem
    key={label}
    aria-label={label?.length ? label : actionText}
    component="a"
    {...rest}
  >
    {menuIcon ? (
      <ListItemIcon sx={{ minWidth: '28px !important' }}>
        {menuIcon}
      </ListItemIcon>
    ) : null}
    <Typography {...textProps}>{actionText}</Typography>
  </MenuItem>
);
